import { ComponentAPI } from '@philips-internal/oswald-ui-core';
export default class CardAppointmentsDetailDateStateAPI extends ComponentAPI {
}
//# sourceMappingURL=card-appointments-detail-date-state-api.js.map